import React from 'react';
import { useAppSelector } from "../../../hooks/app";
import { getEndorsements } from "../../../store/slices/endorsement.slice";
import { getInstructors } from "../../../store/slices/instructor-student.slice";
import { getRequestFormData } from "../../../store/slices/request-signature.slice";
import { RATING_TYPES } from '../../../constants';

function StepThree({ flights }: { flights: any }) {
  const requestFormData = useAppSelector(getRequestFormData)
  const instructors = useAppSelector(getInstructors)
  const endorsements = useAppSelector(getEndorsements)


  const [instructor, setInstructor] = React.useState<any>(null)
  const [selectedValues, setSelectedValues] = React.useState<any>(null)

  React.useEffect(() => {
    if (requestFormData?.instructorId) {
      setInstructor(instructors?.find((instructor: any) => instructor?.userId?._id === requestFormData.instructorId))
    }

    if (requestFormData?.type === "1") {
      setSelectedValues(endorsements.find((endorsement: any) => endorsement._id === requestFormData.endorsementId))
    }
    if (requestFormData?.type === "0") {
      setSelectedValues(flights?.filter((flight: any) => requestFormData.flightId?.includes(flight._id)))
    }

  }, [requestFormData, instructors, endorsements, flights])



  return (
    <div className="signature_step__two">
      <h3 className="heading3 text-center">Following request will be sent</h3>
      <div className="input_group text-left">
        <div className="mb-2 d-flex flex-column align-items-start">
          <label>Instructor: </label>
          <h3 className="heading3">{instructor?.userId?.firstname} {instructor?.userId?.lastname}</h3>
        </div>

        {requestFormData?.type === "0" ? <>
          <label>Flights to sign: </label>
          {selectedValues?.map((value: any) => (
            <div key={value?._id} className="d-flex flex-column align-items-start">
              <h3 className="heading3">{value?.flightNumber}</h3>
            </div>
          ))}
        </> : null}
        {requestFormData?.type === "1" ? <>
          <div className="d-flex flex-column align-items-start">
            <label>Endorsement to sign: </label>
            <h3 className="heading3">{selectedValues?.name}</h3>
          </div>
        </> : null}
        {requestFormData?.type === "2" ? <>
          <div className="mb-2 d-flex flex-column align-items-start">
            <label>Rating To Sign: </label>
            <h3 className="heading3"> {RATING_TYPES[requestFormData?.ratingType]['label']} ({RATING_TYPES[requestFormData?.ratingType]['models'][requestFormData?.ratingModal]})</h3>
          </div>
        </> : null}
      </div>
    </div>
  );
}

export default StepThree;
